import React from "react";
import cns from "classnames";
import { animation } from "polished";
import { withStyles } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import MicIcon from "@material-ui/icons/Mic";
import MicNone from "@material-ui/icons/MicNone";
import { Classes, ThemeType } from "@theme";

type OwnProps = {
  disabled?: boolean;
  off?: boolean;
  online?: boolean;
  onClick?: (e: React.SyntheticEvent<any>) => void;
};

type Props = OwnProps & {
  classes: Classes<typeof styles>;
};

class SpeechRecMic extends React.Component<Props> {
  render() {
    const { classes, disabled, off, onClick, online } = this.props;

    const Icon = off ? MicNone : MicIcon;

    const className = cns(classes.root, {
      [classes.online]: online,
      [classes.enabled]: !disabled,
      [classes.disabled]: disabled
    });

    return (
      <IconButton disabled={disabled} onClick={(e) => !disabled && onClick && onClick(e)}>
        <Icon className={className} />
      </IconButton>
    );
  }
}

const styles = (theme: ThemeType) => ({
  root: {
    color: theme.palette.grey[500]
  },

  enabled: {
    cursor: "pointer"
  },

  online: {
    color: "#FF00007F",
    ...animation(["flash", "2500ms", "infinite"])
  },

  disabled: {
    color: theme.palette.disabled.main
  }
});

export default withStyles(styles as any)(SpeechRecMic);
